import {Button, DialogTrigger, Label, Text} from 'react-aria-components'
import styled from 'styled-components'
import {FocusBorderCss} from '../base/base.styled'
import {DropdownIcon} from '../media/icons/dropdown-icon/dropdown-icon'
import Popover from '../base/popover/popover.styled'
import {mediumSmallFont, smallFont} from '../../theme/font-styles'
import {spacing} from '../../theme/spacing'
import {VesselSelector} from './vessel-selector'

const Styled = {
    Root: styled.div`
        display: grid;
        grid-template-columns: 1fr auto;
        grid-template-areas:
            'label'
            'button'
            'help';
    `,
    DialogTrigger: styled(DialogTrigger)``,
    Label: styled(Label)`
        grid-area: label;
        ${mediumSmallFont()}
    `,
    Text: styled(Text)`
        grid-area: help;
        ${smallFont()}
    `,
    ComboBoxLikeButton: styled(Button)<{background?: string; isDark?: boolean}>`
        grid-area: button;
        display: grid;
        grid-template-areas: 'content icon';
        grid-template-columns: 1fr auto;
        padding: ${spacing(2)} ${spacing(2)} ${spacing(2)} ${spacing(2)};
        min-width: 250px;
        background: ${({background, theme, isDark}) =>
            background || (isDark ? 'black' : theme.colors.background.default)};
        color: ${({theme}) => theme.colors.text.default};

        border: 1px solid ${({theme}) => theme.colors.border.default};
        border-radius: 4px;

        &[data-pressed] {
            ${FocusBorderCss}
        }

        &[data-disabled],
        &[data-disabled] svg {
            cursor: not-allowed;
        }

        &[data-disabled]:not([data-loading]),
        &[data-disabled]:not([data-loading]) svg {
            opacity: 0.5;
        }
    `,
    Content: styled.div`
        grid-area: content;
        overflow: hidden;
        display: flex;
        column-gap: ${spacing(1)};
        align-items: center;
        margin-right: ${spacing(1)};
    `,
    DropdownIcon: styled(DropdownIcon)`
        grid-area: icon;
        cursor: pointer;
        margin-left: -${spacing(1)};
    `,
    Popover: styled(Popover)<{width?: number; isDark?: boolean}>`
        ${
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            ({width}) => (width ? `width: ${width}px;` : '')
        }
        background: ${({theme, isDark}) => (isDark ? 'black' : theme.colors.background.default)};
        color: ${({theme}) => theme.colors.text.default};
        overflow-y: auto;
    `,
    FilterSummaryResult: styled.span`
        color: ${({theme}) => theme.colors.text.default};
        white-space: nowrap;
    `,
    CenteredSpan: styled.span`
        text-align: center;
        width: 100%;
    `,
    FilterSummaryPrefix: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 ${spacing(1)};
        color: ${({theme}) => theme.colors.text.secondary};
    `,
    FilterSummarySpan: styled.span`
        margin: 0 0 0 ${spacing(2)};
    `,
    FilterSummaryCount: styled.span`
        text-wrap-mode: nowrap;
        display: block;
        overflow-x: hidden;
        flex-shrink: 0;
    `,
    VesselSelector: styled(VesselSelector)``,
}

export default Styled
